export default __webpack_public_path__ + "static/media/tectonic.66df146e.svg";